import { render, staticRenderFns } from "./MapPoint.vue?vue&type=template&id=ed1c0e2a&"
import script from "./MapPoint.vue?vue&type=script&lang=js&"
export * from "./MapPoint.vue?vue&type=script&lang=js&"
import style0 from "./MapPoint.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports